<template>
    <v-container fluid style="padding: 55px 35px 40px 35px">
        <v-card v-if="isReady" class="background-summary-card" v-resize="onResize">
            <v-card-title class="pa-0 mb-5">
                <v-row no-gutters class="font-theme standard-row pb-7" align="center" justify="space-between">
                    <v-col md="auto" lg="auto">
                        <v-slide-group show-arrows mandatory v-model="permissionTabs" color="black">
                            <v-slide-item v-slot="{ active, toggle }" value="">
                                <v-btn active-class="select-header-summary-tabs"
                                    class="font-for-header-summary-tabs font-theme" height="52" :input-value="active"
                                    depressed rounded text @click="toggle">
                                    All
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-for="(permissionTabs) in summaryPermissionTab" :key="permissionTabs.value"
                                v-slot="{ active, toggle }" :value="permissionTabs.value">
                                <v-btn active-class="select-header-summary-tabs"
                                    class="font-for-header-summary-tabs font-theme" height="52" :input-value="active"
                                    depressed rounded text @click="toggle">
                                    {{ permissionTabs.name }}
                                </v-btn>
                            </v-slide-item>
                        </v-slide-group>
                    </v-col>
                    <v-col md="auto" lg="" v-if="windowSize.x >= 600">
                        <span class="d-flex mt-5 mt-sm-0 justify-end">
                            <v-btn rounded color="#0B68D6" class="white--text text-center download-report-inbox-btn"
                                @click="goToDownloadReport()" height="53" width="193"
                                style="font-weight: 700; font-size: 15px;">
                                Download Report
                            </v-btn>
                        </span>
                    </v-col>
                    <v-col cols="1" sm="1" v-if="windowSize.x < 600" class="d-flex justify-end">
                        <template>
                            <v-menu offset-y v-if="permissionTabs !== 'All'">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" color="#414040">
                                        <v-icon size="30">mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list style="background-color: #414040">
                                    <!-- <v-list-item dense @click="toSaveSummaryDialogSelected"
                                        :disabled="selected.length === 0">
                                        <v-list-item-content>
                                            <v-list-item-title class="font-theme white--text"
                                                style="font-size: 16px; line-height: 25px">ตัดงบ</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item> -->
                                    <v-list-item dense @click="goToDownloadReport()">
                                        <v-list-item-content>
                                            <v-list-item-title class="font-theme white--text"
                                                style="font-size: 16px; line-height: 25px;">Dowload
                                                Report</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-col>
                </v-row>
                <v-row no-gutters class="standard-row font-theme" align="center">
                    <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 15px; font-weight: 700"
                        class="ml-4 ml-sm-0">
                        ค้นหาเลขที่เอกสาร
                    </v-col>
                    <v-col cols="" sm="4" md="4" lg="4" class="ml-2">
                        <v-text-field v-if="windowSize.x >= 960" dense outlined hide-details color="black"
                            background-color="white" v-model="holdKeyword"
                            @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)"
                            @input="!holdKeyword ? checkRowsAndPageBeforeSearch(holdKeyword) : ''" height="42"
                            class="font-theme summary-text-field">
                        </v-text-field>
                        <v-text-field v-else dense outlined hide-details color="black" background-color="white"
                            height="42" v-model="holdKeyword" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)"
                            @input="!holdKeyword ? checkRowsAndPageBeforeSearch(holdKeyword) : ''"
                            class="font-theme custom-search-text-field">
                            <template v-slot:append v-if="windowSize.x < 960">
                                <v-btn icon style="margin-top: 3px">
                                    <v-icon size="38"
                                        @click="checkRowsAndPageBeforeSearch(holdKeyword)">mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col sm="auto" md="auto" lg="auto" class="ml-2">
                        <v-btn v-if="windowSize.x >= 960" rounded color="#0B68D6" class="white--text" height="42"
                            width="125" @click="checkRowsAndPageBeforeSearch(holdKeyword)"
                            style="font-weight: 700; font-size: 15px; box-shadow: none">
                            ค้นหา
                        </v-btn>
                        <v-select v-if="windowSize.x < 960" :items="statusDocument" hide-details outlined dense
                            height="42" item-text="status" item-value="value" v-model="documentStatus"
                            append-icon="mdi-chevron-down" background-color="white" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="custom-search-dropdown pt-3">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme"
                                        style="font-size: 12px; font-weight: 700; line-height: 30px;">
                                        {{ data.item.status }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col v-if="windowSize.x >= 960" cols="12" sm="12" md="auto" lg="auto"
                    class="mt-2 d-flex justify-space-between">
                    <v-btn class="font-theme btn-select-all" :disabled="isSaveBudget.length === 0"
                        style="font-size: 12px;" @click="toggleSelectAll">
                        <v-checkbox :class="isSaveBudget.length === 0 ? 'disabled-checkbox' : 'checkbox-select-all'"
                            v-model="selectAll" disabled></v-checkbox>เลือกทั้งหมด
                    </v-btn>
                </v-col>
                <v-col v-if="windowSize.x < 960 && windowSize.x > 600" cols="12" sm="12" md="auto" lg="auto"
                    class="mt-2 d-flex justify-space-between">
                    <v-btn class="font-theme btn-select-all" :disabled="isSaveBudget.length === 0"
                        style="font-size: 12px;" @click="toggleSelectAll">
                        <v-checkbox :class="isSaveBudget.length === 0 ? 'disabled-checkbox' : 'checkbox-select-all'"
                            v-model="selectAll" disabled></v-checkbox>เลือกทั้งหมด
                    </v-btn>
                    <v-btn @click="toSaveSummaryDialogSelected" :disabled="selected.length === 0"
                        style="font-size: 12px;" class="ml-3 font-theme btn-select-all">
                        <v-icon color="#000000" style="padding: 5px;">
                            mdi-square-edit-outline
                        </v-icon>
                        ตัดงบ</v-btn>
                </v-col>
                <v-col v-if="windowSize.x < 600" cols="12" sm="12" md="auto" lg="auto"
                    class="mt-2 d-flex justify-center">
                    <v-btn class="font-theme btn-select-all" :disabled="isSaveBudget.length === 0"
                        style="font-size: 12px;" @click="toggleSelectAll">
                        <v-checkbox :class="isSaveBudget.length === 0 ? 'disabled-checkbox' : 'checkbox-select-all'"
                            v-model="selectAll" disabled></v-checkbox>เลือกทั้งหมด
                    </v-btn>
                    <v-btn @click="toSaveSummaryDialogSelected" :disabled="selected.length === 0"
                        style="font-size: 12px;" class="ml-3 font-theme btn-select-all">
                        <v-icon color="#000000" style="padding: 5px;">
                            mdi-square-edit-outline
                        </v-icon>
                        ตัดงบ</v-btn>
                </v-col>
                <v-col cols="11" sm="11" md="auto" lg="auto" class="ml-2 mt-2">
                    <v-slide-group v-if="windowSize.x >= 960" show-arrows mandatory v-model="documentStatus">
                        <v-slide-item v-slot="{ active, toggle }" value="">
                            <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab"
                                @click="toggle" height="41" depressed rounded text>
                                <v-badge inline color="#3B639F" :content="countIsSaveBudget[''].toString()"
                                    style="font-weight: 700; font-size: 12px;" class="summary-badge-content">
                                    เอกสารทั้งหมด
                                </v-badge>
                            </v-btn>
                        </v-slide-item>
                        <v-slide-item v-slot="{ active, toggle }" value="บันทึกงบสำเร็จ">
                            <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab"
                                @click="toggle" height="41" depressed rounded text>
                                <v-badge inline color="#08aa0e"
                                    :content="countIsSaveBudget['บันทึกงบสำเร็จ'].toString()"
                                    style="font-weight: 700; font-size: 12px;" class="summary-badge-content">
                                    บันทึกงบสําเร็จ
                                </v-badge>
                            </v-btn>
                        </v-slide-item>
                        <v-slide-item v-slot="{ active, toggle }" value="ยังไม่บันทึกงบ">
                            <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab"
                                @click="toggle" height="41" depressed rounded text>
                                <v-badge inline color="#eb1f1f"
                                    :content="countIsSaveBudget['ยังไม่บันทึกงบ'].toString()"
                                    style="font-weight: 700; font-size: 12px;" class="summary-badge-content">
                                    ยังไม่บันทึกงบ
                                </v-badge>
                            </v-btn>
                        </v-slide-item>
                    </v-slide-group>
                </v-col>
                <v-col class="mt-2" align="end" style="font-size: 12px; font-weight: 700;" v-if="windowSize.x >= 960">
                    <v-btn @click="toSaveSummaryDialogSelected" :disabled="selected.length === 0"
                        style="font-size: 12px;" class="font-theme btn-select-all">
                        <v-icon color="#000000" style="padding: 5px;">
                            mdi-square-edit-outline
                        </v-icon>
                        ตัดงบ</v-btn>
                </v-col>
            </v-row>
            <v-data-table :headers="headers" range :items="myItem" :options.sync="optionsDataTable"
                :server-items-length="countIsSaveBudget[documentStatus]"
                class="list-data-table-summary-finance pt-3 font-theme" fixed-header
                :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า', }">
                <template v-slot:[`item.select`]="{ item }">
                    <v-checkbox v-if="item.status_document === false && callApiPending === 0" v-model="selected"
                        :value="item" class="checkbox-select-all" style="margin-right: 8px">
                    </v-checkbox>
                </template>
                <template v-slot:[`item.status_document`]="{ item }">
                    <span v-if="item.status_document == true" style="color: #08aa0e"><v-icon
                            color="#08aa0e">mdi-circle-medium</v-icon>บันทึกงบสําเร็จ</span>
                    <span v-if="item.status_document == false" style="color: #eb1f1f"><v-icon
                            color="#eb1f1f">mdi-circle-medium</v-icon>ยังไม่บันทึกงบ</span>
                </template>
                <template v-slot:[`item.description`]="{ item, index }">
                    <div class="expand-cell" @click="toggleExpand(index)">
                        <!-- ไอคอน -->
                        <v-icon size="35" class="mr-2" style="vertical-align: middle; cursor: pointer;">
                            {{ expandedRows[index] ? 'mdi-menu-up' : 'mdi-menu-down' }}
                        </v-icon>
                        <div v-if="expandedRows[index]" class="expand-content">
                            <div v-for="(desc, i) in item.description || []" :key="i">
                                <div v-for="n in 10" :key="n">
                                    <span v-if="desc['sub_item' + n]">
                                    {{ desc['sub_item' + n] }}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </template>
                <template slot="no-data">
                    <v-alert class="text-center d-flex justify-center">
                        ไม่พบข้อมูล
                    </v-alert>
                </template>
                <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                </template>
            </v-data-table>
        </v-card>
        <DownloadReportModal />
        <SaveCutBudgetModal />
    </v-container>
</template>
<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import DownloadReportModal from '../components/DownloadReportModal.vue'
import SaveCutBudgetModal from '@/components/SaveCutBudgetModal.vue'
export default {
    components: {
        DownloadReportModal,
        SaveCutBudgetModal
    },
    data: () => ({
        summaryPermissionTab: [
            { name: 'เงินยืม', value: 'ใบยืมเงินทดรอง' },
            { name: 'เงินคืน', value: 'ใบคืนเงินทดรอง' }
        ],
        isReady: false,
        windowSize: { x: 0, y: 0 },
        optionsDataTable: { page: 1, itemsPerPage: 20 },
        countItem: 0,
        countIsSaveBudget: '',
        documentStatus: '',
        selected: [],
        myItem: [

        ],
        selectAll: false,
        permissionTabs: '',
        statusDocument: [
            { status: 'เอกสารทั้งหมด', value: '' },
            { status: 'บันทึกงบสำเร็จ', value: 'บันทึกงบสำเร็จ' },
            { status: 'ยังไม่บันทึกงบ', value: 'ยังไม่บันทึกงบ' },
        ],
        headers: [
            {
                text: "",
                value: "select",
                align: "center",
                sortable: false,
                width: "50px",
            },
            {
                text: "วันที่ส่งเอกสาร",
                value: "created_at",
                align: "center",
                sortable: false,
                width: "160px",
            },
            {
                text: "เลขที่เอกสาร",
                value: "document_id",
                align: "center",
                sortable: false,
                width: "160px",
            },
            {
                text: "ผู้ส่งเอกสาร",
                value: "full_name",
                align: "center",
                sortable: false,
                width: "160px",
            },
            {
                text: "Position",
                value: "position",
                sortable: false,
                align: "center",
                width: "150px",
            },

            {
                text: "Department",
                value: "department",
                align: "center",
                sortable: false,
                width: "180px",
            },
            {
                text: "ประเภทเอกสาร",
                value: "doc_type",
                sortable: false,
                align: "center",
                width: "180px",
            },
            {
                text: "อ้างอิงเอกสาร",
                value: "ref_doc_adv",
                sortable: false,
                align: "center",
                width: "180px",
            },
            {
                text: "Description",
                value: "description",
                align: "center",
                sortable: false,
                width: "380px",
            },
            {
                text: "ยอดเงิน",
                value: "total_payment",
                align: "center",
                sortable: false,
                width: "120px",
            },
            {
                text: "สถานะ",
                value: "status_document",
                align: "center",
                sortable: false,
                width: "150px",
            },
            {
                text: "วันที่บันทึกงบ",
                value: "updated_at",
                align: "center",
                sortable: false,
                width: "150px",
            },
            {
                text: "งบที่บันทึก",
                value: "budget_type",
                align: "center",
                sortable: false,
                width: "150px",
            },
        ],

        expandedRows: {},
        save_budget: '',
        isSaveBudget: [],
        headersTable: [],
        holdKeyword: '',
        callApiPending: 0,
        maxSelect: 10
    }),
    watch: {
        selected(newValue, oldValue) {
            if (newValue.length > this.maxSelect) {
                this.$nextTick(() => {
                this.selected = oldValue
                })
                return
            }

            if (this.isSaveBudget.length === 0) {
                this.selectAll = false
                return
            }

            this.selectAll =
            newValue.length === Math.min(this.isSaveBudget.length, this.maxSelect)
        },

        myItem: {
            handler(newValue) {
            this.isSaveBudget = (newValue || []).filter(
                e => e.status_document === false
            )
            },
            immediate: true
        },
        "optionsDataTable.page"() {
            this.getAllItem();
            this.selectAll = false;
            this.selected = [];
        },
        "optionsDataTable.itemsPerPage"() {
            this.getAllItem();
            this.selected = [];
            this.selectAll = false;
        },
        "permissionTabs"() {
            this.holdKeyword = ''
            this.document_id = ''
            this.optionsDataTable.page = 1
            this.getAllItem();
            this.selectAll = false;
        },
        "documentStatus"(val) {
            if (val === 'บันทึกงบสำเร็จ') {
                this.save_budget = 'true';
            } else if (val === 'ยังไม่บันทึกงบ') {
                this.save_budget = 'false';
            } else {
                this.save_budget = '';
            }
            this.optionsDataTable.page = 1
            this.selected = [];
            this.selectAll = false;
            this.getAllItem();
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
            this.selected = [];
            this.selectAll = false;
        }
    },
    computed: {
        selectedBiz() {
          return this.$store.state.confirmSelectedBiz
        },
    },
    mounted() {
        this.getAllItem();
        this.onResize();
        EventBus.$on('toSummaryModal', this.resetPage);
    },
    beforeDestroy() {
        EventBus.$off('toSummaryModal');
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth };
        },
        checkRowsAndPageBeforeSearch(params) {
            this.document_id === params
            this.document_id = params.trim()
            this.checkPageForGetTransaction()
        },
        checkPageForGetTransaction() {
            if (this.optionsDataTable.page === 1) {
                this.getAllItem()
            } else {
                this.optionsDataTable.page = 1
            }
        }, 
        toSaveSummaryDialogSelected() {
            var selectedToSave = [...this.selected]
             if(this.permissionTabs === 'ใบยืมเงินทดรอง'){
                this.permissionTabToDialogs = 'เงินยืม'
            }else if(this.permissionTabs === 'ใบคืนเงินทดรอง'){
                this.permissionTabToDialogs = 'เงินคืน'
            }else{
                this.permissionTabToDialogs = 'All'
            }
            EventBus.$emit('toSaveSummaryFinance', selectedToSave, this.permissionTabToDialogs) 
        }, 
        toggleExpand(index) {
            this.$set(this.expandedRows, index, !this.expandedRows[index]);
        },
        async getAllItem() {
            this.callApiPending++;
            this.isReady = false;
            try {

                const searchTransactions = {
                    baseURL: this.$api_url,
                    url: `/summary_finance/api/v1/get_summary_finance?document_status=${this.save_budget || ''}&offset=${(this.optionsDataTable.page - 1) * this.optionsDataTable.itemsPerPage || 0}&limit=${this.optionsDataTable.itemsPerPage}&type=${this.permissionTabs || ''}&search=${this.holdKeyword || ''}&tax_id=${this.selectedBiz.tax_id || ''}`,
                    method: 'GET'
                };
                const response = await this.axios(searchTransactions);
                if (response.data.status && response.data.data.data.length) {
                    response.data.data.data.forEach(item => {
                        item.created_at = `${MainFunction.shortDate(item.created_at)} ${MainFunction.shortTime(item.created_at)}` || '-';
                        item.updated_at = item.updated_at ? `${MainFunction.shortDate(item.updated_at)} ${MainFunction.shortTime(item.updated_at)}` : '-';
                        if(item.doc_type ===  'ใบยืมเงินทดรอง'){
                             item.total_payment =  MainFunction.addComma(parseFloat(String(item.total_advance_payment === '-' ? '0' : item.total_advance_payment).replace(/,/g, '')).toFixed(2)) ;
                        }else{
                             item.total_payment =  MainFunction.addComma(parseFloat(String(item.amount_left === '-' ? '0' : item.amount_left).replace(/,/g, '')).toFixed(2));
                        }    
                    });
                    this.myItem = response.data.data.data;
                    this.countIsSaveBudget = {
                        '': response.data.data.count.status_document_all || 0,
                        'บันทึกงบสำเร็จ': response.data.data.count.status_document_true || 0,
                        'ยังไม่บันทึกงบ': response.data.data.count.status_document_false || 0,
                    };

                    $(".list-data-table-summary-finance > .v-data-table__wrapper").scrollTop(0);
                } else {
                    this.myItem = [];
                }

            } catch (error) {
                this.myItem = [];
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error');
                console.log(error);
            } finally {
                this.isReady = true;
                this.callApiPending--;
                this.trigRowPerPage = false;
            }
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selected = []
                this.selectAll = false
                return
            }

            const selectable = this.isSaveBudget.slice(0, this.maxSelect)
            this.selected = selectable
            this.selectAll = true

            if (this.isSaveBudget.length > this.maxSelect) {
                this.alert(
                `เลือกได้สูงสุด ${this.maxSelect} รายการ`,
                "Warning",
                "info"
                )
            }
        },
        resetPage() {
            location.reload();
        },
        goToDownloadReport() {
            const aboutReport = {
                url: '/summary_finance/api/v1/report_summary_finance',
                permission: this.permissionTabs,
                from: 'summaryFinance'
            }
            EventBus.$emit('openDownloadReportModal', aboutReport)
        },
        alert(title = '', text = 'Warning', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    },
};
</script>
<style>
.background-summary-card {
    border-radius: 23px !important;
    background: #f1f1f1;
    box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.25);
    padding: 30px;
    max-width: 100%;
}

.btn-select-all {
    background-color: #D9D9D9;
    margin-bottom: 0px;
    border-radius: 12px;
    border: 1px solid #000000;
    color: #000000;
}

.checkbox-select-all {
    padding-left: 3px;
}

.checkbox-select-all .v-input__slot>.v-label {
    font-size: 12px;
    color: black;
}

.checkbox-select-all :before,
::after {
    text-decoration: inherit;
    vertical-align: inherit;
    color: black;
}

.disabled-checkbox {
    padding-left: 3px;
}

.disabled-checkbox .v-input__slot>.v-label {

    color: #d2d1d180;
    /* Style when disabled */
}

.btn-select-all:not(.v-btn--round).v-size--default {
    padding: 0 10px 0 2px;
}

.summary-text-field {
    border-radius: 30px !important;
}

.summary-text-field.v-text-field--outlined fieldset {
    border-color: black !important;
}

.select-header-summary-tabs {
    background: #d2d1d180 !important;
    color: black !important;
}

.font-for-header-summary-tabs {
    font-family: 'Sarabun', sans-serif;
    font-size: calc(100% + 0.56vw) !important;
    font-weight: 700;
    letter-spacing: 2px;
    color: #8D8D8D !important;
}

.font-for-header-summary-tabs:before {
    background: transparent !important;
}

.summary-text-field .v-input__control .v-input__slot .v-text-field__slot input {
    margin-left: 5px;
    margin-right: 5px;
}

.summary-text-field .v-input__control .v-input__slot .v-text-field__slot input {
    line-height: 30px;
}


.font-for-header-summary-tabs {
    font-family: 'Sarabun', sans-serif;
    font-size: calc(100% + 0.56vw) !important;
    font-weight: 900;
    letter-spacing: 2px;
    line-height: 43.57px;
    color: #8D8D8D !important;
}

.font-for-header-summary-tabs:before {
    background: black !important;
}

.select-header-summary-tabs {
    background: none !important;
    color: black !important;
}

.list-data-table-summary-finance .v-data-table__wrapper table .v-data-table-header tr th {
    background-color: #F1F0F0;
    height: 56px;
    box-shadow: none;
}

.list-data-table-summary-finance.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover {
    cursor: pointer;
}

.list-data-table-summary-finance .v-data-table__wrapper table tbody tr td {
    font-size: 12px;
    border-bottom: none !important;
    font-weight: 700;
    font-style: Bold;
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;

}

.list-data-table-summary-finance {
    border-radius: 10px;
    overflow-y: auto;
}

.list-data-table-summary-finance .v-data-table__wrapper table .v-data-table-header tr th {
    background-color: #000000;
    color: #D9D9D9;
    height: 56px;
    font-size: 16px;
    box-shadow: none;
}

.list-data-table-summary-finance .v-data-table-header tr {
    position: sticky !important;
    top: 0;
    z-index: 1;
    background-color: #000000 !important;
    box-shadow: none;
}

.list-data-table-summary-finance .v-data-table-header tr::after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #000000
}

.list-data-table-summary-finance thead th:first-child {
    border-radius: 5px 0 0 0;
}

.list-data-table-summary-finance thead th:last-child {
    border-radius: 0 5px 0 0;
}

.list-data-table-summary-finance .v-data-table__wrapper table thead tr th {
    font-size: 12px;
}

.list-data-table-summary-finance.v-data-table>.v-data-table__wrapper {
    height: calc(100vh - 259px);
    overflow: auto;
    scroll-behavior: smooth;
}

.list-data-table-summary-finance.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.list-data-table-summary-finance.v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

.list-data-table-summary-finance.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #F7F6F6;
    ;
}

.list-data-table-summary-finance>.v-data-table__wrapper>table>thead>tr>th {
    color: rgb(244, 243, 243) !important;
}

.custom-search-dropdown-eval-vender.v-select.v-input--dense .v-select__selection--comma {
    margin-left: 5px;
}

.custom-search-dropdown-eval-vender.v-text-field:not(.v-text-field--single-line) input {
    margin-left: 5px;
    line-height: 30px;
}

.custom-search-dropdown-eval-vender .v-input__control .v-input__slot .v-select__slot .v-select__selections {
    line-height: 30px;
}

@media only screen and (max-width: 600px) {

    .list-data-table-summary-finance .v-data-table__wrapper table tbody tr td:last-child {
        border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
    }

    .list-data-table-summary-finance .v-data-table__wrapper table tbody tr:last-child td {
        border-bottom: none !important;
    }

    .list-data-table-summary-finance .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td:last-child {
        border-bottom: none !important;
    }

    .list-data-table-summary-finance .v-data-table__empty-wrapper {
        display: flex;
        justify-content: center;
    }
}

.expand-cell {
    cursor: pointer;
    padding: 8px;
}

.expand-content {
    margin-top: 6px;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
    font-size: 14px;
    color: #444;
}
</style>
